import Image from 'next/image';
import Link from 'next/link';
import React from 'react';
import { ProfileRoute } from 'services/routes';
import { TeacherType } from 'types/course.type';
import user from 'public/user.svg';

const TeacherAvatar: React.FC<{ teacher: TeacherType }> = ({ teacher }) => {
  return (
    <Link
      href={ProfileRoute(teacher.id, teacher.nickname || teacher.family)}
      key={teacher.id}
      passHref
    >
      <a className="center mx-[24px] min-w-[130px] flex-col text-gray-10 cursor-pointer my-[10px] transition-all duration-300 text-center xl:opacity-70 hover:opacity-100 hover:text-blue-2 xl:grayscale-[.5] hover:grayscale-0">
        <Image
          src={teacher.avatar || user}
          width={130}
          height={130}
          alt={teacher.nickname}
          className="rounded-full "
        />
        <h3 className="text-[16px] my-[5px] font-bold">
          {teacher.nickname || teacher.family}
        </h3>
      </a>
    </Link>
  );
};

export default TeacherAvatar;
